export const API_URL = "https://aso-reset-password.azurewebsites.net";
export const BLOB_URL = "https://asoresetpassword.blob.core.windows.net";